import { FormFieldHOC } from '../HOCs';
import { MainCoverageSection as _MainCoverageSection } from './Section';
export type { MainCoverageSectionProps } from './Section';
export const MainCoverageSection = FormFieldHOC(_MainCoverageSection as any);
export * from './Block';
export * from './Price';
